@use '~/theme/theme' as *;

.iconContainer {
  @include border-radius(full);

  width: 100%;
  background: color(teal-300);
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
}

.icon {
  width: 75%;
}

.additionalContent {
  padding: spacing(2);
  gap: spacing(2);
  white-space: nowrap;

  > * {
    flex-shrink: 0;
  }
}
